<template lang="pug">
.text-frame.line-height-default
  slot
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

/**
 * 文字列を表示するdiv要素のエリア
 */
@Component
export default class TextFrame extends Vue {}
</script>

<style lang="stylus" scoped>
.text-frame
  display block
</style>
